import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate?: () => boolean;
  canDeactivateWithCallback?: () => { value: boolean; cb: (a: boolean) => void };
}

@Injectable()
export class UnsavedFormGuard {
  title = this.translate.instant('common.alert') + '!';
  description = this.translate.instant('common.unsaved-form');
  constructor(
    private location: Location,
    private router: Router,
    private modalService: NzModalService,
    private translate: TranslateService,
  ) {}

  canDeactivate(component: CanComponentDeactivate, currentRoute: ActivatedRouteSnapshot) {
    const navObject = this.router.getCurrentNavigation();
    if (navObject?.extras?.state?.bypassGuard) return true;

    const canDeactivateWithCallback =
      typeof component.canDeactivateWithCallback !== 'undefined' ? component.canDeactivateWithCallback() : null;

    if (
      (typeof component.canDeactivate !== 'undefined' && !component.canDeactivate()) ||
      canDeactivateWithCallback?.value === false
    ) {
      const data$: Observable<boolean> = new Observable((observer) => {
        this.modalService.create({
          nzTitle: this.title,
          nzContent: this.description,
          nzOnOk: () => {
            canDeactivateWithCallback?.cb(true);
            observer.next(true);
            observer.complete();
          },
          nzOnCancel: () => {
            canDeactivateWithCallback?.cb(false);
            // https://github.com/angular/angular/issues/13586
            // remove this workaround once upgraded to v12
            const currentUrlTree = this.router.createUrlTree([], currentRoute);
            const currentUrl = currentUrlTree.toString();
            if (!this.location.path().endsWith(currentUrl)) this.location.go(currentUrl);
            observer.next(false);
            observer.complete();
          },
        });
      });
      return data$;
    }
    return true;
  }
}
